
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class IncomeTaxSlabDetailsEditor extends _Ext.GridEditorBase<IncomeTaxSlabDetailsRow> {
        protected getColumnsKey() { return 'HR.IncomeTaxSlabDetails'; }
        protected getDialogType() { return IncomeTaxSlabDetailsDialog; }
        protected getLocalTextPrefix() { return IncomeTaxSlabDetailsRow.localTextPrefix; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}